import environment from '@src/Infra/Config';
import {AIProducts, AIProductsResponse} from '@Data/Model/AIProducts';
import axios from 'axios';

export default function getSearch(parameters: AIProducts) {
  let url = `${environment.stream}/medias/${parameters.mediaCode}/ai-products?formatted-markdown=true&`;

  url += parameters.products.map((product) => {
    return `product-types=${product}`;
  }).join('&');

  return axios
    .get(url, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + parameters.authorization,
      },
    })
    .then((response): AIProductsResponse => {
      const body = response.data;

      if (response.status === 200) {
        return {
          success: true,
          mindMap: body.find((item: any) => item?.type === 'MIND_MAP')?.mindmap,
          summary: body.find((item: any) => item?.type === 'SUMMARY')?.summary,
          summaryText: body.find((item: any) => item?.type === 'SUMMARY_TEXT')?.summary,
          questions: (body.find((item: any) => item?.type === 'QUESTION')?.questions || []).map((item: any, index: number) => ({
            ...item,
            number: index,
          })),
          // content: {...body},
        };
      }

      return {
        success: false,
        mindMap: '',
        summary: '',
        summaryText: '',
        questions: [],
        // message: response.statusText,
      };
    });
}
